<!-- 在线缴费 -->
<template>
    <div class="el-letterAdmission">
        <el-row class="page_content">
            <h1 class="head_title">打印录取通知书</h1>
            <el-row v-if="imgUrl != null" style="max-width: 800px;text-align: center;margin: 0 auto;">
                <div id='printBill'>
                    <img width="100%" :src="imgUrl" alt="" style="vertical-align:top">
                </div>
            </el-row>
            <el-row v-if="imgUrl != null" style="text-align: center;margin-bottom: 20px;">
                <el-button type="primary" @click="printNow">打印</el-button>
            </el-row>
        </el-row>
    </div>
</template>
<script>
import print from "print-js";
// import imgUrl from '@/images/imgUrl.jpg'; //录取通知书
export default {
    name: "LetterAdmission",
    data() {
        return {
            imgUrl: null
        };
    },
    created() {
        this.getUseImgTemplate();
    },
    methods: {
        printNow() { //打印录取通知书
            const style = '@media print { @page {size: auto; margin: 0; } body{margin:0 0}}'//打印时去掉眉页眉尾
            //打印为什么要去掉眉页眉尾？因为眉页title时打印当前页面的title，相当于是获取html中title标签里面的内容，但是比如我打印的内容只是一个弹框里面的内容，是没有title的，这时候就会出现undefined，为了避免出现这种情况，就可以隐藏眉页眉尾
            printJS({
                printable: 'printBill',// 标签元素id
                type: 'html',
                header: null,
                targetStyles: ['*'],
                style
            });
        },
        getUseImgTemplate() { //获取录取通知书
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/useImgTemplate", {templateName: "录取通知书"}).then((ret) => {
                loading.close();
                if (ret.code == 0) {
                    if (ret.data.length > 0) {
                        this.imgUrl = this.$isHttp(ret.data[0]);
                    } else {
                        this.$message({message: "通知书生成失败！", type: "warning"});
                    }
                } else {
                    this.$message({message: ret.msg, type: "warning"});
                }
            }).catch(err=>{
                loading.close();

            })
        }
    }
};
</script>
<style lang="less">
@import '../styles/base.less';

.el-letterAdmission {
    .wd {
        color: @red;
    }

    // .el-dialog__body{
    //     border-top:1px solid #ebeef5;
    // }
}
</style>



// WEBPACK FOOTER //
// src/pages/LetterAdmission.vue